export default {
  titleBanner: {  
    subtitle: 'UWB | ウルトラワイドバンド',
    title: 'UWBの位置測位とポジショニング技術',
    description: '*UWBは、非常に広い帯域幅を持つ無線通信技術であり、非常に短時間で非常に強力な信号を送信する技術です。 <br/> UWBは、位置測位やレーダーアプリケーションなど、高い精度とデータ転送速度を提供することができます。'

  },
  tech: {
    title: 'UWB技術とは何ですか？',
    text: 'ウルトラワイドバンド（UWB）は、無線通信に使用される短距離RF技術であり、人、デバイス、資産の位置を理論的にも非常に高い精度で検出することができます。 BluetoothやWi-Fiなどの他の通信プロトコルと同様に、UWBはラジオ波を使用してデバイス間でデータを送信することができます。これには短いナノ秒パルスが使用され、"ウルトラワイド"な周波数範囲で通信が行われます。 <br/><br/> UWB技術は、最小500MHzまたは中心周波数の20％を超える広い周波数スペクトラムを横断する10億以上のラジオパルスを、ナノ秒ごとにパターンで送信します。この信号は送信機から受信機または受信機間で送信されます。受信デバイスは受信したパターンを解析し、データに変換します。これにより、デバイスは短い距離内で高速データ転送だけでなく、UWB信号を使用してデバイスの位置を正確に検出することも可能です。これにより、UWB機能を備えたデバイス（スマートフォンやセンサーなど）は、他のスマートフォンやアセットトラッキングタグなどの送信機を正確に位置付け、特定のアプリケーションで位置認識通信とサービスを可能にします。 <br/><br/> 最新のスマートフォンや他の技術では、最近採用されて新しい先端技術のように見えるかもしれませんが、UWB技術は数十年にわたって適用されてきました。長い間、その使用は制限されていましたが、軍事レーダーや通信アプリケーションなどで一般的に「パルスラジオ」という名前で見ることができました。 2002年にFCCがライセンスなしの使用を承認した後、UWB技術は革新と発展を繰り返し、革新的な位置情報ベースの機能を解放する出発点となりました。'
  },
  selection: {
    title: 'UWBの採用が増加しています',
    text: '多くの大手企業がUWBのさまざまな可能性に気付き、UWB搭載ソリューションの開発やリリースを始めました。その中でも特に注目すべき企業の1つであるAppleは、iPhone 11のリリースと同時に新しいU1超広帯域チップを搭載してUWB技術を実現し始めました。サムスンなど他の企業もこれに続いて一部の最新のスマートフォンや他のデバイスにUWB技術を搭載し始めました。GoogleもAndroidデバイスでUWBを使用するアプリケーションを可能にするAPIの開発に着手しています。 <br/><br/> 現在では、さまざまな種類のデバイスに組み込むことができる十分に小さなハードウェアコンポーネントが費用効果の高い選択肢となっています。NFLはさらに、超広帯域技術を使用して選手のリアルタイムの位置と動きを測位しています。選手のショルダーパッドにUWBチップを取り付け、リーグは試合中に選手がどのように動くかを分析することができます。 NXPとVolkswagenはUWBを自動車に使用し、より安全で便利な車のエクスペリエンスを提供する可能性を探っています。さらに、UWBアライアンスやFIRAなどのコンソーシアム、およびさまざまなUWBハードウェア企業など、UWB技術開発の先駆者が存在します。これらの企業は、特定の使用例に応じてさまざまなUWBチップ、アンカー、およびタグを提供しています。一部の専門家は、UWB技術が近い将来、BluetoothやWi-Fiと同様に普及し、一部はBLEを置き換えて短距離通信と位置確認の主要な標準として確立されると予測しています。'
  },
  feature: {
    title: 'UWBの特長',
    text: 'UWB技術は、RF技術の新しい標準を迅速に確立するために多くの独自の利点を持っています。この技術は、短い距離で非常に高速なデータ転送を提供し、リアルタイムで正確な位置を把握することができます。UWB技術は、3.1から10.6GHzの非常に広い周波数スペクトラムで広帯域で動作します。さらに、電力消費が非常に低く、トラッキングタグなどの低コストで効率的なハードウェアオプションを可能にします。これらのタグはコイン型電池で駆動され、数年間の充電や交換なしに動作することができます。 <br/><br/> UWBが非常に正確に位置を検出できる理由は、デバイス間の時間-距離測定（Time-of-Flight、ToF）に基づいて距離を計算するためです。これにより、無線波が1つのデバイスから別のデバイスに移動するのにかかる時間を計算します。この方法は通常、短い距離でのみ動作しますが、最適な条件と配置では、UWB信号の位置を50cm以下の精度で特定し、非常に低い待ち時間を示すことができます。一方、BLEやWi-Fiなどの他の技術は通常、受信信号強度指標（RSSI）を使用して位置を決定し、その場合の精度はメートル単位に制限されることが一般的です。 <br/><br/> UWB信号の低電力送信と広い周波数スペクトラムは、周囲の狭帯域技術とほとんど干渉しないようにします。また、UWBは「ノイズフロアにも見えない」とされ、狭い帯域RF技術との共存に適しています。これらの独特の特性により、UWBは屋内のプレミアムな位置情報技術として急速に台頭しているのです。'
  },
  howItWorks: {
    title: 'UWBポジショニングの仕組み',
    text: 'UWBはToFにより位置を決定することができます。これは、デバイス間で信号が移動するのにかかる時間を計算し、送受信機間の距離を正確に測定することができます。一部のシナリオでは、デバイスの位置のX、Y、Z座標も検出でき、これによりUWBが提供する位置指定に追加の次元を加えることができます。使用例やアプリケーションによってToFの計算方法は異なる場合があります。 <br/><br/> UWB位置測定では、Time Difference of Arrival（TDoA）とTwo-Way Ranging（TWR）という2つの基本技術を使用することができます。',
    items: [
      {
        title: 'Time Difference of Arrival（TDoA）',
        description: 'TDoAは、屋内空間全体に配置された固定の位置にあるUWBアンカーやセンサーを使用します。これらのセンサーは、トラッキングタグなどのUWBデバイスを検出し、位置を特定します。固定されたアンカーは正確に同期し、同じクロックで動作する必要があります。UWBタグや他のデバイスは定期的に信号を送信します。これらの信号は通信範囲内のすべてのアンカーによって受信され、アンカーによってタイムスタンプが付けられます。次に、すべてのタイムスタンプデータが中央のIPSまたはRTLSに送信されます。 <br/><br/> 位置エンジンは、各アンカーのデータと到着時間の差を分析し、双曲線を描き、双曲線が交差する交点を使用してタグの座標を計算します。これらの座標は、デバイスの位置を空間の屋内マップ上に可視化したり、特定のアプリケーションに応じて他の目的に使用することができます。'
      },
      {
      title: 'Two-Way Ranging（TWR）',
      description: 'TWRは、2つのデバイス間の双方向通信を使用して距離を測定する技術です。たとえば、スマートフォンなどのデバイスが互いに近づいている場合、2つのデバイスはお互いの距離を測定し始めます。2つのデバイス間で信号が送信されるまでにかかる時間は、光の速さと乗算され、相対的な位置を決定します。この技術は通常、位置認識通信を可能にするために使用されます。 <br/><br/> TWRは、固定アンカーとUWBデバイスの間でも使用できますが、TWRプロセスは1度に1つの測定パートナーのみを使用してデバイスの位置を特定することができます。'
      }
    ]
  },
  accuracy: {
    title: 'UWBポジショニングの精度はどれくらいですか？',
  text: 'UWBはナノ秒のパルスと他のRF送信との制限された干渉により、最適な条件と配置で50cm未満の精度で正確な屋内位置測位が可能です。リアルタイムな結果でデバイスの動きや操作も素早く測位できます。 <br/><br/>他の屋内位置技術と比較して、UWBは卓越した位置精度を提供します。他の標準では一般的に受信信号強度指標（RSSI）を使用して位置を決定し、BLE（< 5m）やWi-Fi（< 10m）などの精度でしか動作しません。一部のUWB技術では方向検出を介してより正確な位置測定も可能であり、これには多重アンテナデバイスが必要です。'
  },
  range: {
    
    title: 'UWBの通信範囲はどのくらいですか？',
    text: 'UWBはデバイスの位置を200メートル以下の範囲で検出できます。ただし、通常は1〜50メートルの短距離で最も効果的に動作し、デバイスやアンカー間に視野が確保されている場合に最良の結果が得られます。UWBは短距離で非常に正確で高速な安全な通信を提供し、最小限の干渉を維持することができます。'
  },
  difference: {
    title: 'UWBは他のポジショニング技術とどのように異なりますか？',
    text: '各RF標準には独自の特性と利点があり、個々の要件、予算、施設、および特定の位置ベースのユースケースに応じて適切なオプションとなります。UWBと他の技術との最も重要な違いは、広い周波数スペクトルと提供できる精度レベルです。UWBの精度は、絶対的な位置とリアルタイムの移動が重要なアセットトラッキングシナリオなどの高度な屋内位置ベースのユースケースで特に効果的なオプションです。',
    items: [
      {
      title: 'UWB vs Bluetooth',
      description: 'UWBとBLEは多くの共通点を持っています-低電力、低コスト、アセットトラッキング技術の利点など。ただし、UWBはBluetoothよりもはるかに優れた精度を提供することができます。これはUWBのToFによる正確な距離ベースの位置特定方法によるものです。BLEの位置技術は通常、RSSIを使用してデバイスの位置を決定し、デバイスがビーコンやセンサーに対して強力な信号または弱い信号を送信するかに応じて、かなり低い精度を提供します。BLEはUWBよりもはるかに短い範囲とデータレートを持ち、信号干渉に対しても脆弱です。Bluetoothは巨大なエコシステムを持ち、非常に人気のある位置技術の1つです。多くの無線デバイスで使用され、BLEビーコンなどの柔軟なハードウェアオプションを簡単に実装できます。'
      },
      {
      title: 'UWB vs Wi-Fi',
      description: 'Wi-Fiはデバイスと屋内空間での広範な使用のため、屋内位置技術の主要なRFテクノロジーとなっています。ただし、高度な位置ベースのシナリオでは、Wi-Fiの精度と柔軟性に制約がある場合があります。これらの高度なアプリケーションでは高い精度が必要であり、そのためにはUWB技術が優れています。Wi-Fiは距離ではなく信号強度を測定するため、UWBに比べて精度が低く、干渉にも影響を受けやすくなります。一方、UWBは強力な耐干渉性を持ち、干渉の問題が少ないです。また、UWBは低電力を必要とするため、コインセルバッテリーで駆動されるアセットトラッキングタグなどの便利で低コストなツールを作成することができます。ただし、Wi-Fiをサポートするさまざまなデバイスやアクセスポイントなどの既存のインフラを活用できる利点がありますので、高精度が必要でない場合には非常に重要な屋内位置技術となります。'
      }
    ]
  },
  advantage: {
    title: 'UWBの主な利点',
    items: {
    accuracy: {
      title: '高い精度',
      description: 'UWB技術はセンチメートルレベルの精度を提供し、以前は不可能だったさまざまな機能を無限に提供します。'
      },
    position: {
      title: 'リアルタイムポジショニング',
      description: 'UWB技術は非常に高速な位置決定結果を提供します。ナノ秒単位の高速通信により、真のリアルタイムの屋内位置決定とトラッキングが可能であり、レイテンシが非常に低く、秒間100回以上の更新速度で即座の人員、アセット、または車両の位置、動き、動作を検出できます。'
      },
    security: {
      title: '信頼性とセキュリティ',
      description: 'UWBは他の無線波とほとんど干渉または重ならず、非常に信頼性の高い通信が可能な点が利点です。受信デバイスの正確な位置を使用して、UWBは小さな距離でのデバイス間の非常に安全な通信にも使用できます。'
      },
    }
  },
  useCase: {
    title: 'UWBポジショニングの使用例',
    description: 'UWBの精度は特に高度な精度が必要な高度な屋内位置決定ユースケースで効果的なオプションです。<br/>UWBは将来のRTLS技術を実現し、さまざまなアセットトラッキングアプリケーションでも優れたパフォーマンスを発揮します。<br/>以下は現在使用されている使用例と将来の利用分野です。',
    card: {
      physical: {
        title: '物理的アセットトラッキング',
        description: 'UWBの高い精度はアセットトラッキングの重要なRF基準です。多くの産業分野の組織は、UWBの正確さ、高速性、信頼性を活用して、主要なアセットや装置のリアルタイムな位置と状態を非常に高い精度で測位できます。',
        items: [
          {
          name: '企業',
          description: '大規模な企業キャンパスや施設全体のリソース、アセット、および装置を明確に把握し、生産性とリソースの割り当てを向上させることができます。'
          },
          {
          name: '医療',
          description: 'アセットトラッキング機能を活用して、人工呼吸器や車椅子などの重要な装置の正確な位置を素早く見つけて測位できるようにします。'
          },
          {
          name: '倉庫管理',
          description: '大規模な施設内で、装置、ツール、および在庫の位置を特定するのに役立ちます。特に正確な在庫の位置把握が必要な場合に有用です。'
          },
        ]
        },
      employee: {
        title: '従業員および人員トラッキング',
        description: '組織は、UWBの強力な精度を活用して、従業員や人員の正確な位置を特定し、位置認識アプリケーションを実行できます。',
        items: [
          {
          name: '従業員の安全',
          description: '緊急事態や避難時に従業員や人員の正確な位置を迅速に特定する必要がある場合、UWBの高精度が非常に重要です。'
          },
          {
          name: 'ワークプレイスの準備',
          description: 'UWB従業員タグとバッジを使用して、接触トレースを可能にするツールを活用し、病気の伝播を予防および緩和するためのプロトコルや規制要件をサポートし、物理的な距離の確保の認識、効率的な衛生指示などを提供します。'
          },
        ]
        },
      location: {
        title: 'ロケーションサービス',
        description: '組織は人々とデバイスの正確な位置を活用して、相互作用やメッセージングなどのさまざまな機能を容易にするスマートビルディングを構築できます。',
        items: [
          {
          name: 'プロキシメッセージ',
          description: 'UWBの屋内位置測位技術を導入し、顧客や資産の近くの目的地を特定し、これらのデータを活用してクーポン、マーケティングキャンペーン、近隣観光地などのハイパーローカルなコンテンツを含む対話型顧客エクスペリエンスを促進できます。'
          },
          {
          name: 'ジオフェンシング',
          description: 'さまざまなスペースの周りに仮想的な地理的境界を作成し、ユーザーが指定された領域に入る、出る、または滞在するときに特定のアクションを実行できるようにします。'
          }
        ]
        },
      navigation: {
        title: '屋内ナビゲーション',
        description: 'UWB位置測定技術の高い精度を活用して、屋内ナビゲーションや経路案内機能によってスペースを即座に使い慣れ、探索可能なものにします。',
        items: [
          {
          name: '拡張現実（AR）',
          description: 'UWBの屋内全体での正確な位置情報提供能力は、組織がハイパーローカルかつ没入型の拡張現実体験を提供する新しい機会を生み出すことができます。'
          },
          {
          name: 'Blue-dot Wayfinding',
          description: 'ブルードット（Blue dot）のエクスペリエンスを通じて、ユーザーは屋内空間で自分の位置を正確に把握し、順次案内および経路案内を可能にします。ビジネス、医療、小売、ホテル、交通などのさまざまな産業では、特に正確な屋内体験を提供するために重要な屋内位置技術になります。'
          }
        ]
      },
      business: {
        title: 'ビジネスインテリジェンス',
        description: 'UWBは驚くほど正確な位置データを収集でき、これを強力なインサイトに変換できます。',
        items: [
          {
          name: '分析およびビジネスインテリジェンス',
          description: 'アセット、人員、およびデバイスの位置と移動を把握し、時間の経過とともにこれらの位置データを分析することで、ビジターが屋内スペースと対話する方法を把握し、よりインテリジェントかつ情報化されたビジネスの意思決定を行うための洞察を提供します。'
          }
        ]
        },
      b2b: {
        title: '消費者およびB2Bユースケース',
        description: 'UWBは、短距離通信と位置情報に関するゲームチェンジを実現するため、多くの革新的な消費者ベースのユースケースを開拓しています。',
        items: [
          { name: 'スマートビルディングおよびアクセスコントロール' },
          { name: 'ピアツーピア通信' },
          { name: 'スマートヘルスケアデバイス' },
          { name: '車両アクセスコントロール' },
          { name: '安全な位置情報ベースのモバイル決済' },
          { name: 'スマートホーム' }
        ]
    }
    }
  }
}